import React from 'react'
import { Text } from "@nextui-org/react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// import messages
import ErrorMessage from '../../../components/ui/messagesandalerts/error'
import SuccessMessage from '../../../components/ui/messagesandalerts/success'

function CreateNewCard() {
  const authToken = Cookies.get("authToken")

  const [cardpurpose, setcardpurpose] = React.useState()
  const [cardmonthlimit, setcardmonthlimit] = React.useState()

  const navigate = useNavigate();
  const [error, setError] = React.useState("")
  const [successMessage, setSuccessMessage] = React.useState("")
  const [proccessing, setProccessing] = React.useState(false)

  const [cardid, setcardid] = React.useState()

  const CreateTheCard = ((e) => {
    e.preventDefault();
    setProccessing(true)
    axios.post('https://sea-turtle-app-vo8po.ondigitalocean.app/cards/addnew',
      {
        cardpurpose,
        cardmonthlimit
      },
      {
        headers: {
          "Content-Type": "application/json",
          "authToken": authToken
        },
      }
    ) 
      .then(function (response) {
        let cardid = response.data.cardid
        setProccessing(true)

        setError("")
        setSuccessMessage("Successfully created card. Please wait .. Redirecting you now.")

        const timeOut = setTimeout(navigateFunction, 2000)

        function navigateFunction() {
          navigate(`/account/cards/${cardid}`);
        }
      })
      .catch(function (error) {
        setProccessing(false)
        console.log(error.response.data.message);
        setSuccessMessage("")
        setError(error.response.data.message)
      });
  })

  return (
    <div className='accountForms'>
      <Text>
        Create New Card
      </Text>

      {/* create new card form */}
      <div className="mt-6">
        <form action="#" method="POST" className="max-w-3xl mt-8 px-5 pb-10 createNewCardForms p-" onSubmit={CreateTheCard}>
         
          <div className="messagesDiv mb-10 mt-5">
            {
              error && <ErrorMessage message={error} />
            }

            {
              successMessage && <SuccessMessage message={successMessage} />
            }

          </div>

          <div className="space-y-8">
            <div className="sm:flex sm:items-start w-full">
              <label htmlFor="fullname" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2 sm:w-1/4">
                Card Purpose / Name
              </label>
              <div className="mt-2 sm:mt-0 sm:w-3/4 w-full">
                <input
                  value={cardpurpose}
                  onChange={(e) => setcardpurpose(e.target.value)}
                  type="text"
                  name="fullname"
                  id="text"
                  placeholder=""
                  className="border block w-full px-4 py-3 placeholder-gray-500 border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm caret-indigo-600 formsInputs"
                />
              </div>
            </div>


            <div className="sm:flex sm:items-start">
              <label htmlFor="fullname" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2 sm:w-1/4">
                Card Spending Limit - optional
              </label>
              <div className="mt-2 sm:mt-0 sm:w-3/4">
                <input
                  value={cardmonthlimit}
                  onChange={(e) => setcardmonthlimit(e.target.value)}
                  type="text"
                  name="fullname"
                  id="text"
                  placeholder=""
                  className="border block w-full px-4 py-3 placeholder-gray-500 border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm caret-indigo-600"
                />
              </div>
            </div>

          </div>

          <div className="mt-6 sm:mt-12">

            {
              proccessing &&
              <button
                className="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-semibold leading-5 text-white transition-all duration-200 bg-gray-400 border border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 hover:bg-gray-400"
                disabled
              >
                <h5 className="upgradeNowText">
                  Creating Card. Please Wait
                </h5>
              </button>

              ||
              <button
                type="submit"
                className="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-semibold leading-5 text-white transition-all duration-200 bg-red-600 border border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 hover:bg-red-500"
              >
                <h5 className="upgradeNowText">
                  Create and Save Card
                </h5>
              </button>
            }

          </div>
        </form>
      </div>

    </div>
  )
}

export default CreateNewCard